import React from "react";

function Footer() {
    return (
        <footer>
            Copyright © 2022 ChargeIt.com
        </footer>
    );
}

export default Footer;